import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';

import { environment } from '../../../environments/environment';

@Injectable()
export class DeviceGuard implements CanActivate {
    constructor(public router: Router) { }
    canActivate() {
        const isMobile = window.innerWidth < environment.pixelBreakpointSmallScreen;
        if (isMobile) {
            this.router.navigate(['/map']);
            return false;
        } else { return true; }
    }
}
